import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col items-center justify-center w-full h-full text-center px-4",
  style: {"font-size":"32px","padding-left":"40px","padding-right":"40px","font-weight":"bold","color":"white"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "We can't connect you because we don't find your microphone.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("ul", {
  style: {"font-size":"16px","list-style":"disc"},
  class: "text-left"
}, [
  /*#__PURE__*/_createElementVNode("li", null, "1. Make sure your microphone is plugged in and set up to work."),
  /*#__PURE__*/_createElementVNode("li", null, "2. Make sure your browser is allowed to access the mic"),
  /*#__PURE__*/_createElementVNode("li", null, "3. Make sure your page has been allowed to acess the mic by browser settings"),
  /*#__PURE__*/_createElementVNode("li", null, "4. Reload the page or try in another browser")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "videoWrapper" }

import { computed, onMounted, ref, watch } from "vue";
import { useSession } from "./composables/session"
import LoginView from "./views/LoginView.vue";
import { usePage } from "./composables/page";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const room = useSession().room
const isLogged = computed(() => !!room.value)
const previewPlayer = ref(null as null | HTMLVideoElement);
const failToConnect = ref(false)

onMounted(async () => {
  //WILL REQUEST DE MIC PERMISSION
  navigator.mediaDevices
    .getUserMedia({
      audio: true,
    })
    .then(function (stream: any) {
      navigator.mediaDevices
        .getUserMedia({
          audio: true,
        })
        .then(function (copystream: any) {
          useSession().setSelfStream(stream, copystream);
          useSession().muteMic(true);
          if (previewPlayer.value && useSession().myStream.value)
            previewPlayer.value.srcObject = useSession().myStream.value!.stream;
        })
        .catch(function (err) {
          failToConnect.value = true;
        });
    })
    .catch(function (err) {
      failToConnect.value = true;
    });
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (failToConnect.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!isLogged.value)
            ? (_openBlock(), _createBlock(LoginView, { key: 0 }))
            : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
        ], 64)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("video", {
        ref_key: "previewPlayer",
        ref: previewPlayer,
        class: "user-div",
        autoplay: "",
        muted: ""
      }, null, 512)
    ])
  ], 64))
}
}

})